module.exports = __webpack_public_path__ + "static/media/dontcopy2.3de3011a.gif";